import { FORMAL_ASSESSMENT_TEMPLATES_LIST } from "config/apiPaths";
import { schoolReportsApi } from "./schoolReports";

export const assessmentTemplates = schoolReportsApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssessmentTemplates: builder.query({
      query: (data) => {
        return {
          url: FORMAL_ASSESSMENT_TEMPLATES_LIST,
          method: "PATCH",
          data
        }
      },
      transformResponse: (response) => {
        return response?.data;
      }
    }),
  }),
});

export const {
  useLazyGetAssessmentTemplatesQuery,
} = assessmentTemplates;